<template>
    <div no-interact>
        <pc-label
            v-if="label"
            v-bind="labelBinder"
            v-on:help-clicked="$emit('help-clicked', $event)" />
        <input
            v-bind="binder"
            ref="input"
            v-model="internalValue"
            v-bind:disabled="disabled || readonly"
            v-bind:max="max"
            v-bind:min="min"
            v-bind:step="step"
            class="form-range pc-range"
            type="range"
            v-on="listeners" />
        <div
            v-if="showValidationErrors"
            class="invalid-feedback fw-bold">
            {{ validationError }}
        </div>
    </div>
</template>

<script>
    import base from "./_inputBase.vue";
    export default {
        extends: base,
        props: {
            modelValue: { type: Number, required: false, default: null },
            min: { type: Number, required: false, default: null },
            max: { type: Number, required: false, default: null },
            step: { type: Number, required: false, default: null }
        },
        emits: ["help-clicked"]
    };
</script>

<style lang="scss" scoped></style>
